<template>
  <div class="main_container" v-loading.fullscreen.lock="loadingpage">
    <van-nav-bar title="监测地图" :fixed="true" @click-right="showSetting">
      <template #right>
        <van-icon name="setting-o" />
      </template>
    </van-nav-bar>

    <!-- <el-dialog
      :visible.sync="isShowSetting"
      width="40%">
      <div
        class="tools"
        style="background-color: #fff; border-radius: 3px; padding: 0 3px;"
      >
        <el-checkbox v-model="showOutLine" style="color: #333; font-weight: bold">显示未在线设备</el-checkbox>
      </div>
    </el-dialog> -->
    <div class="body">
      <div class="head">
        <div class="nav" v-if="!page_config.showHistory">
        更新于: {{ update_time }}
          <span>
            <span
              v-show="data_type != 'wind_direction'"
              style="margin-left: 10px"
              >均值： {{ avg_val }}{{ getUnit(data_type) }}</span
            >
            <span
              v-show="data_type == 'wind_direction'"
              style="margin-left: 10px"
              >均值： {{ avg_val | calc_direction }}</span
            >
          </span>

        </div>
        <div class="select">
          <div class="screen_menus" :class="!page_config.showHistory ? 'screen_menus_current' : ''">
            <van-row gutter="20">
              <van-col span="8" style="border-right: 1px solid #e5e5e5">
                <div
                  class="screen_menu"
                  @click="showRegionSelect = !showRegionSelect"
                >
                  <span class="screen_menu_text">{{
                    region && region.label
                  }}</span>
                  <van-icon
                    name="arrow"
                    style="font-size: 12px"
                    :class="{ active_icon: showRegionSelect }"
                  />
                </div>
              </van-col>

              <van-col span="8" style="border-right: 1px solid #e5e5e5">
                <div
                  class="screen_menu"
                  @click="showTimeSelect = !showTimeSelect"
                >
                  {{ timep && timep.label }}
                  <van-icon
                    name="arrow"
                    style="font-size: 12px"
                    :class="{ active_icon: showTimeSelect }"
                  />
                </div>
              </van-col>

              <van-col span="8" style="border-right: 1px solid #e5e5e5">
                <div
                  class="screen_menu"
                  @click="showTypeSelect = !showTypeSelect"
                >
                  {{ type_name }}
                  <van-icon
                    name="arrow"
                    style="font-size: 12px"
                    :class="{ active_icon: showTypeSelect }"
                  />
                </div>
              </van-col>
            </van-row>
            <van-row class="time-sel" v-if="page_config.showHistory">
              <div style="text-align: left; padding-left: 18px">
                <span :class="timeLabel == '历史' ? 'lable' : ''"
                  >{{ timeLabel }}:</span
                >
                <span style="position: relative">
                  <van-icon name="calendar-o" class="calendar" />
                  <input
                    :class="timeLabel == '历史' ? 'baseipt lable' : 'baseipt'"
                    type="text"
                    v-model="update_time"
                    :disabled="timep.value === 'min'"
                    @click="showPopTime"
                    @focus="hideVk"
                    style="position: relative; width: 144px"
                  />
                </span>
                <span style="padding-left: 7px">
                  <span v-show="data_type != 'wind_direction'"
                    >均值:{{ avg_val }}{{ getUnit(data_type) }}</span
                  >
                  <span v-show="data_type == 'wind_direction'"
                    >均值:{{ avg_val | calc_direction }}</span
                  >
                </span>
                <van-icon
                  style="padding-left: 5px"
                  color="#018bff"
                  name="replay"
                  v-show="timeLabel == '历史'"
                  @click="resetTime"
                />
              </div>
            </van-row>
          </div>

          <transition name="showlist">
            <van-radio-group class="popup" id="pop1" v-show="showRegionSelect">
              <van-cell
                class="select-cell"
                :class="{ cellActive: item.value == region.value }"
                v-for="item in option_region"
                :key="item.value"
                clickable
                :value="item.label"
                @click="(region = item), (showRegionSelect = false)"
              ></van-cell>
            </van-radio-group>
          </transition>

          <transition name="showlist">
            <van-radio-group class="popup" id="pop2" v-show="showTimeSelect">
              <van-cell
                class="select-cell"
                :class="{ cellActive: item.value == timep.value }"
                v-for="item in option_time"
                :key="item.value"
                clickable
                :name="item.value"
                :value="item.label"
                @click="(timep = item), (showTimeSelect = false)"
              ></van-cell>
            </van-radio-group>
          </transition>

          <transition name="showlist">
            <van-radio-group class="popup" id="pop3" v-show="showTypeSelect">
              <van-cell
                class="select-cell"
                :class="{ cellActive: type.value == data_type }"
                v-for="type in option_data_type"
                :key="type.label"
                clickable
                :value="type.label"
                @click="
                  (data_type = type.value),
                    (type_name = type.label),
                    (showTypeSelect = false)
                "
              ></van-cell>
            </van-radio-group>
          </transition>
        </div>
      </div>
      <!--选择时间  -->
      <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          :type="dateType"
          title="选择完整时间"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showTime = false"
          @confirm="confirmPicker"
          @change="dateChange"
          :filter="filterTime"
        />
      </van-popup>
      <!-- 不在线提示 -->
      <div class="offline_tip" v-show="offline_tip_show">
        <span>
          <van-icon name="volume-o" color=" #1890ff" />
          <span>{{ tipTime }}标站数据还未更新</span>
        </span>
        <van-icon
          name="close"
          color=" #1890ff"
          @click="offline_tip_show = false"
        />
      </div>
      <div
        v-if="limitVal"
        class="tools"
        style="
          position: fixed;
          z-index: 1;
          top: 110px;
          right: 3px;
          background-color: #fff;
          border-radius: 3px;
          padding: 0 3px;
          color: #3d759e;
        "
      >
        <span>标准限值：</span>
        <span>{{ limitVal }}</span>
      </div>

      <div
        class="chart"
        id="map"
        style="
          margin-top: 0px;
          height: calc(100vh - 145px);
          background: black;
          width: 100%;
        "
      ></div>
      <van-popup
        style="
          width: 250px;
          padding: 10px 15px;
          border-radius: 8px;
          top: 33%;
          box-shadow: 0 2px 8px rgba(9, 14, 82, 0.28);
        "
        v-model="showInfoWindow"
        :overlay="true"
      >
        <div>
          <div style="color: #565656">
            {{ station.station.Name }}
            <!-- <van-icon
              name="close"
              size="20px"
              style="float:right;"
              @click="showInfoWindow=false"
            /> -->
          </div>
          <div v-if="station.sensor.data_status == 'empty'">
            <div class="infotime">
              离线时间：{{ station.offline.offline_time }}
            </div>
            <div class="infotime">离线原因：{{ station.offline.desc }}</div>
            <div
              :style="{
                background: `url(${station.offline.img})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                width: '250px',
                height: '120px',
              }"
              @click="showBigImg(station.offline.img)"
            ></div>
            <!-- <img width="250" height="120" :src="station.offline.img" alt="离线图片"> -->
          </div>
          <div v-else>
            <div class="infotime">
              <div>时间：</div>
              <div>{{ station.sensor.TIME }}</div>
            </div>
            <el-popover
              v-if="levelInfoDetail"
              placement="right-end"
              width="190"
              v-model="isShowLevelInfo"
              trigger="click"
              class="levelInfo"
            >
              <p class="levelInfoDetail">
                <span>
                  <i class="el-icon-warning"></i>
                  地表水环境质量标准限值：{{ levelInfoDetail.name }}</span
                >
              </p>
              <p class="levelInfoDetail">
                <span>COD：{{ levelInfoDetail.cod }}</span>
                <span>氨氮：{{ levelInfoDetail.ammonia_nitrogen }}</span>
              </p>
              <p class="levelInfoDetail">
                <span>总磷：{{ levelInfoDetail.phosphorus }}</span>
                <span>PH：{{ levelInfoDetail.ph }}</span>
              </p>
              <span slot="reference"
                >执行标准：地表水{{ levelInfoDetail.name }}</span
              >
            </el-popover>
            <div class="option_data_type" v-if="option_data_type">
              <div v-for="item of option_data_type" :key="item.value">
                <div class="tb_label">{{ item.label }}</div>
                <div class="tb_value" :style="sensorColor(item.value)">
                  <span>{{ sensorValue(item.value) }}</span>
                  <sub style="bottom: 0">{{ item.unit }}</sub>
                </div>
              </div>
              <!-- <div class="tb_label">PM10:</div><div class="tb_value" :style="{background:getPMInfo(station.sensor.pm10, 'pm10').bgcolor}">{{station.sensor.pm10}}</div> -->
            </div>
          </div>

          <!-- <div v-show="station.sensor.wendu || station.sensor.shidu">
                <div class="tb_label">温度:</div><div class="tb_value">{{station.sensor.wendu}}</div>
                <div class="tb_label">湿度:</div><div class="tb_value">{{station.sensor.shidu}}</div>
                </div>

                <div v-show="station.sensor.wind_speed || station.sensor.wind_direction">
                <div class="tb_label">风速:</div><div class="tb_value">{{station.sensor.wind_speed}}</div>
                <div class="tb_label">风向:</div><div class="tb_value">{{station.sensor.wind_direction}}</div>
          </div>-->
          <div>
            <div class="tb_label">查看:</div>
            <div class="tb_value" style="border: none">
              <a @click="clickRow(station)" style="color: #3ad4ff">详细数据</a>
              <navigate :station="station"></navigate>
            </div>
          </div>
        </div>
      </van-popup>

      <van-popup
        v-model="isShowSetting"
        :overlay-style="{
          backgroundColor: 'transparent',
          marginTop: '100px',
          height: '75vh',
        }"
        style="
          width: 130px;
          padding: 10px;
          position: fixed;
          top: 136px;
          right: 10px;
          transform: translateX(18%);
          border-radius: 4px;
        "
      >
        <div
          class="tools"
          style="background-color: #fff; border-radius: 3px; padding: 0 3px"
        >
          <el-checkbox v-model="showOutLine" style="font-weight: bold"
            >显示未在线设备</el-checkbox
          >
          <el-checkbox v-model="showNameAlways" style="font-weight: bold"
            >始终显示名称</el-checkbox
          >
          <div v-if="page_config.add_gf_station">
            <van-divider style="margin: 6px 0" />
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            >
              <span style="font-weight: bold">显示标站</span>
            </el-checkbox>
            <div style="margin: 5px 0 0 22px">
              <el-checkbox-group
                v-model="checkedLevels"
                @change="handleCheckedLevelsChange"
              >
                <el-checkbox
                  v-for="item in station_level_options"
                  :label="item"
                  :key="item"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <!-- <div v-if="page_config.add_gf_station">
            <van-divider style="margin: 6px 0" />
            <el-checkbox v-model="showWind">
              <span style="font-weight: bold">显示风向</span>
            </el-checkbox>
          </div> -->
        </div>
      </van-popup>

      <van-dialog
        v-model="stationTipShow"
        show-cancel-button
        @confirm="viewHourStation"
        @cancel="handleCancel"
        confirmButtonText="切换"
      >
        <template slot="default">
          <div
            style="padding: 20px; box-sizing: border-box; text-align: center"
          >
            <p>标站没有实时(分钟)数据</p>
            <p>是否切换到时均查看？</p>
            <!-- <p style="font-size: 12px; color: #ccc; margin-top: 10px;">标站数据描述的是上1小时的均值，微站实时数据描述的是上1分钟的均值。</p> -->
          </div>
        </template>
      </van-dialog>
    </div>
    <!-- 色条 -->
    <colorBar
      :drawValue="data_type"
      :colorRangeDefault="colorRange"
      colorType="static"
      :barType.sync="barType"
    ></colorBar>

    <!-- 标识 -->
    <!-- <div class="tag_marker" v-if="page_config.add_marker_tag" :style="{bottom: barType == 'gradient' ? '80px': '96px'}"> -->
      <!-- <van-tag type="primary">微站 ▲</van-tag> -->
      <!-- <van-tag type="primary">标站 ★</van-tag> -->
      <!-- <van-tag type="primary">自建微站 ●</van-tag> -->
    <!-- </div> -->
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import {
  option_time,
  waterTypes,
  waterStandards,
  station_level_options,
} from "../../option/option.js";
import { addMarker } from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
import weizhanoverlayfn from "../../option/overlays";
import massFeatures from "../../option/pointOverlays";
import colorBar from "../../components/commons/colorBar";
import { map_theme } from "@/option/map_theme2";
import { ImagePreview } from "vant";
import navigate from '@/components/navigate'
Object.freeze(option_time);
Object.freeze(waterStandards);

export default {
  name: "mapData",
  data() {
    return {
      option_time,
      waterStandards,
      station_level_options,
      page_config: _page_config,
      initFirst: true,
      loadingpage: false,
      showRegionSelect: false,
      showTimeSelect: false,
      showTypeSelect: false,
      type_name: "PM₁₀",
      timep: option_time[0],
      data_type: "pm10",
      region: {},
      myChart: "",
      showOutLine: false,
      showNameAlways: false,
      update_time: "",
      avg_val: 0,
      addLis: 0,
      marker_contain: [],
      mapvLayer: "",
      dataSet: "",
      get_data_int: "",
      arrFeatures: [],
      outlineFeatures: [],
      showInfoWindow: false,
      html_content: "",
      station: { station: {}, sensor: {} },
      isShowSetting: false,
      isShowLevelInfo: false,
      levelInfoDetail: null,
      isIndeterminate: false,
      checkAll: false,
      checkedLevels: [],
      offline_tip_show: false,
      start_t: "--",
      stationTipShow: false,
      clickInMarker: false,
      // 显示风向
      showWind: false,
      // 时间组件
      minDate: new Date(2018, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showTime: false,
      timeLabel: "更新至",
      dateType: "date",
      mondays: [],
      barType: 'gradient'
    };
  },
  components: {
    colorBar,
    navigate
  },
  filters: {
    fil(v) {
      if (v >= 10) {
        return parseInt(v);
      } else {
        return v.toFixed(2);
      }
    },
    calc_direction(v) {
      if (v) {
        let descs = ["北", "东北", "东", "东南", "南", "西南", "西", "西北"];
        let index = Math.floor((v + 22.5) / 45) % 8;
        return descs[index];
      } else {
        return "";
      }
    },
  },
  mounted() {
    //   默认值
    this.initFirst = true;
    this.loadingpage = true;
    this.map = null;
    this.map_zoom = 6;
    this.gfMarkers = [];
    this.wzMarkersPoints = [];
    this.wzMarkers = [];
    const { timeType, dataType, showOutLine, showNameAlways } = this.mapStatus;
    if (timeType) {
      this.timep = timeType;
    }
    if (dataType) {
      this.data_type = dataType;
    }
    if (showOutLine) {
      this.showOutLine = showOutLine;
    }
    if (showNameAlways) {
      this.showNameAlways = showNameAlways;
    }
    this.initMap();
    // 初始化微站绘制类
    this.weizhanoverlayfn = weizhanoverlayfn();
    this.weizhanmassFeatures = massFeatures();

    if (this.userInfo) {
      this.getUserStationsFun('cur')
    }
    // 定时更新
    this.addInterval();
    console.log("mapData mounted");
  },
  beforeDestroy() {
    if (this.get_data_int) {
      clearInterval(this.get_data_int);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "detailData") {
      this.saveMapStatus();
    }

    if (this.get_data_int) {
      clearInterval(this.get_data_int);
    }
    next();
  },
  computed: {
    ...mapState([
      "stations",
      "userInfo",
      "option_region",
      "mapStatus",
      "gfStationData",
      "projectInfo"
    ]),
    ...mapGetters(["option_data_type"]),
    points_group: function () {
      var points_group = [];
      if(this.stations && this.stations.length) {
        var stations = this.stations;
        if (!Object.keys(this.region).length) {
          return;
        }
        if (this.region.value === 0) {
          for (var i in stations) {
            const { Lng, Lat } = this.stations[i].path;
            if (!Lng || Lng === null || !Lat || Lat === null) {
              continue;
            }
            var p = new BMap.Point(Lng, Lat);
            p.info = stations[i];
            points_group.push(p);
            const timesArr = stations
              .filter(item => item.sensor && item.sensor.TIME)
              .map(item => item.sensor.TIME)
              .sort((a, b) => Date.parse(a) - Date.parse(b));
            if (timesArr.length) {
              this.update_time = timesArr[timesArr.length - 1] || "--";
              if (moment(this.update_time).isValid()) {
                this.update_time = moment(this.update_time).format("YYYY-MM-DD HH:mm:00");
              }
            }  
          }
          this.loadingpage = false;
          return points_group;
        }
        for (var i in stations) {
          if (
            stations[i].path.id3 == this.region.value ||
            stations[i].path.id2 == this.region.value ||
            stations[i].path.id1 == this.region.value
          ) {
            const { Lng, Lat } = this.stations[i].path;
            if (!Lng || Lng === null || !Lat || Lat === null) {
              continue;
            }
            var p = new BMap.Point(Lng, Lat);
            p.info = stations[i];
            points_group.push(p);
          }
          var t_need = true;
          var t = this.stations[i].sensor.TIME;
          if (t && t_need == true) {
            if (this.timep.value == "hour") {
              this.update_time = moment(t).format("yyyy-MM-DD HH");
            } else if (this.timep.value == "min") {
              this.update_time = moment(t).format("yyyy-MM-DD HH:mm");
            } else if (this.timep.value == "day") {
              this.update_time = moment(t).format("yyyy-MM-DD");
            } else if (this.timep.value == "week") {
              this.update_time = moment(t).format("yyyy-MM-DD");
            } else if (this.timep.value == "month") {
              this.update_time = moment(t).format("yyyy-MM");
            } else if (this.timep.value == "year") {
              this.update_time = moment(t).format("yyyy");
            } else {
            }
            if (moment(this.update_time).isValid()) {
              this.update_time = moment(this.update_time).format("YYYY-MM-DD HH:mm:00");
            }
            t_need = false;
          }
        }
        this.loadingpage = false;
      }
      return points_group;
    },
    colorRange() {
      if (!G_SENSOR_DATA_TYPE_INFO) {
        return;
      }
      let colorRange = [];
      G_SENSOR_DATA_TYPE_INFO.forEach((item) => {
        if (item.value === this.data_type) {
          colorRange[0] = item["color_range_min"];
          colorRange[1] = item["color_range_max"];
        }
      });
      return colorRange;
    },
    intensity() {
      return new colorIntensity.getIntensity({
        dataType: this.data_type,
        max: this.colorRange[1],
        min: this.colorRange[0],
        colorType: "static",
      });
    },
    limitVal() {
      const limit = waterTypes.filter(
        (item) => item.value === this.data_type
      )[0];
      if (limit) {
        return limit.limit;
      } else {
        return null;
      }
    },
    tipTime() {
      console.log('this.start_t',this.start_t)
      if (this.timep.value == "hour") {
        return moment(this.start_t).format("HH:00");
      } else {
        return moment(this.start_t).format("MM-DD");
      }
    },
  },
  watch: {
    projectInfo() {
      console.log(this.projectInfo);
      if (Object.keys(this.projectInfo).length > 0) {
        this.data_type = this.projectInfo.sensorType.split(',')[0]
      }
    },
    option_data_type: {
      handler() {
        if (!this.option_data_type.length) {
          return
        }
        const { dataType } = this.mapStatus;
        if (dataType) {
          this.data_type = dataType;
          this.type_name = this.option_data_type.filter(
            (item) => item.value === dataType
          )[0].label;
        } else {
          this.type_name = this.option_data_type[0].label;
          this.data_type = this.option_data_type[0].value;
        }
      },
      immediate: true,
    },
    option_region: {
      handler() {
        this.region = this.option_region[0];
      },
      immediate: true,
    },
    userInfo() {
     this.getUserStationsFun('cur')
    },
    timep() {
      this.update_time = null;

      this.currentDate = new Date();
      this.resetTime();
      this.addInterval();
      if (this.timep.value == "hour") {
        this.dateType = "datehour";
      } else if (this.timep.value == "min") {
        this.dateType = "date";
      } else if (this.timep.value == "day") {
        this.dateType = "date";
      } else if (this.timep.value == "week") {
        this.dateType = "date";
      } else if (this.timep.value == "month") {
        this.dateType = "year-month";
      } else if (this.timep.value == "year") {
        this.dateType = "year-month";
      }
    },

    points_group() {
      if (!this.map) {
        return;
      }
      this.calcAvg();
      if (this.initFirst) {
        if (this.points_group && this.points_group.length) {
          this.setMapCenter();
          this.initFirst = false;
        }
      } else {
      }
      this.updateOverlays();
    },
    data_type() {
      this.calcAvg();
      if (!this.map) {
        return;
      }
      this.updateOverlays();
    },
    showRegionSelect() {
      if (this.showRegionSelect == true) {
        this.showTimeSelect = false;
        this.showTypeSelect = false;
      }
    },
    showTimeSelect() {
      if (this.showTimeSelect == true) {
        this.showRegionSelect = false;
        this.showTypeSelect = false;
      }
    },
    showTypeSelect() {
      if (this.showTypeSelect) {
        this.showRegionSelect = false;
        this.showTimeSelect = false;
      }
    },
    showOutLine() {
      this.updateOverlays();
    },
    showNameAlways() {
      this.updateOverlays();
    },
    station() {
      this.getLevelInfoDetail();
    },
    checkedLevels() {
      if (this.timep.value == "min") {
        if (this.checkedLevels.length) {
          this.stationTipShow = true;
        }
      } else {
        this.drawGfStation();
      }
    },
    showWind() {
      this.drawWind();
    },
  },
  methods: {
    dateChange(d) {
      if (this.timep.value !== "week") return false;
      let values = d.getValues();
      let monthSt = moment(`${values[0]}-${values[1]}`);
      let monthEnd = moment(`${values[0]}-${values[1]}`).add(1, "months");
      console.log(monthSt, monthEnd);
      let mondays = [];
      while (monthSt < monthEnd) {
        if (monthSt.day() === 1) {
          mondays.push(monthSt.format("DD"));
        }
        monthSt.add(1, "days");
      }
      console.log(mondays);
      this.mondays = mondays;
    },
    hideVk(e) {
      e.target.setAttribute("readonly", true);
      setTimeout(() => {
        e.target.removeAttribute("readonly");
      }, 100);
    },
    filterTime(type, options) {
      if (this.timep.value == "week") {
        if (type === "day") {
          return this.mondays;
        }
      } else if (this.timep.value == "year") {
        if (type === "month") {
          return options.filter((option) => option % 32 === 0);
        }
      }
      return options;
    },
    showPopTime() {
      this.showTime = true;
    },
    // 确认选择的时间
    confirmPicker(val) {
      console.log('confirmPicker',val)
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      let second = val.getSeconds();

      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      if (second >= 0 && second <= 9) {
        second = `0${second}`;
      }

      this.className = "timeClass";
      this.update_time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      if (this.timep.value == "hour") {
        this.update_time = `${year}-${month}-${day} ${hour}:${minute}`;
      } else if (this.timep.value == "day") {
        this.update_time = `${year}-${month}-${day}`;
      } else if (this.timep.value == "week") {
        this.update_time = `${year}-${month}-${day}`;
      } else if (this.timep.value == "month") {
        this.update_time = `${year}-${month}`;
      } else if (this.timep.value == "year") {
        this.update_time = `${year}`;
      }
      if (moment(this.update_time).isValid()) {
        this.update_time = moment(this.update_time).format("YYYY-MM-DD HH:mm:00");
      }
      this.timeLabel = "历史";
      this.showTime = false;

      this.getUserStationsFun('his')
    },
    resetTime() {
      this.timeLabel = "更新至";
      this.currentDate = new Date();
      this.getUserStationsFun('cur')
    },
    getUserStationsFun(flag){
      this.$store.dispatch("getUserStations", {
        groups: this.userInfo.devGroupIds,
        timep: this.timep.value,
        timepoint:
          (this.timep.value === "min" || flag==='cur')
            ? ""
            : moment(this.update_time).format("yyyy-MM-DD HH:mm:SS"),
      }).then(() => {
          this.updateGfStationData()
          this.loadingpage = false;
        })
        .catch((err) => console.log(err));
    },

    ImagePreview,
    showBigImg(img) {
      this.ImagePreview([img]);
    },
    handleCheckAllChange(val) {
      console.log('handleCheckAllChange1--',val)
      this.checkedLevels = val ? station_level_options : [];
      this.isIndeterminate = false;
    },
    handleCheckedLevelsChange(value) {
       console.log('handleCheckedLevelsChange2--',value)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.station_level_options.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.station_level_options.length;
    },
    viewHourStation() {
      this.timep = option_time.filter((item) => item.value == "hour")[0];
      this.drawGfStation();
    },
    handleCancel() {
      if (this.timep.value == "min") {
        this.checkedLevels = [];
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    // 风向
    /* drawWind() {
      this.clearWindMarker();
      this.windMarkers = [];
      if(this.points_group.length) {
        for(let item of this.points_group) {

        }
      }
    },
    clearWindMarker() {
      if(this.windMarkers.length) {
        for(let i of this.windMarkers){
          this.map.removeOverlay(i)
        }
      }
    }, */
    updateGfStationData() {
      let type = this.timep.value;
      // 实时类型不显示标站，实时类型不获取数据
      if (type == "min") {
        this.clearGfMarkers();
        if (this.checkedLevels.length) {
          this.checkedLevels = [];
          this.checkAll = false;
          this.isIndeterminate = false;
          this.offline_tip_show = false;
        }
        return;
      } else {
        // 实时状态不显示标站，只有时均和日均显示
        this.start_t = moment(this.update_time).format("YYYY-MM-DD HH:00:00");
        this.$store
          .dispatch("getGfStationData", {
            type: this.timep.value,
            start_t:
              this.timep.value === "min"
                ? ""
                : moment(this.update_time).format("yyyy-MM-DD HH:mm:SS"),
          })
          .then(() => {
            this.drawGfStation();
          });
      }
    },
    drawGfStation() {
      this.clearGfMarkers();
      if (this.timep.value == "min") {
        return;
      }
      // 所有标站都没数判断为数据未更新状态
      if (this.checkedLevels.length) {
        this.offline_tip_show = this.gfStationData.every(
          (item) => item[this.data_type] == null
        );
      } else {
        this.offline_tip_show = false;
      }

      // 过滤选择相应等级的标站
      let drawData = this.gfStationData.filter((item) => {
        return this.checkedLevels.some(
          (v) => v.split("标站")[0] == item.station_level
        );
      });
      // 绘制
      if (drawData.length) {
        let markers = [];
        var zoom = this.map.getZoom();
        var showName = false;
        var icon = "★";
        if (this.showNameAlways) {
          showName = true;
        } else {
          if (zoom > 13) {
            showName = true;
          }
        }

        for (let item of drawData) {
          let m = addMarker(
            item,
            this.data_type,
            this.map,
            false,
            150,
            icon,
            showName,
            null,
            null,
            this.intensity
          );
          markers.push(m);
        }
        this.gfMarkers = markers;
      }
    },
    clearGfMarkers() {
      if (this.gfMarkers.length) {
        for (let i of this.gfMarkers) {
          this.map.removeOverlay(i);
          this.map.removeOverlay(i.circleMarker);
        }
      }
    },
    showSetting() {
      this.isShowSetting = !this.isShowSetting;
    },
    saveMapStatus() {
      const centerPoint = this.map.getCenter();
      const point = { lng: centerPoint.lng, lat: centerPoint.lat };
      const zoom = this.map.getZoom();
      const timeType = this.timep;
      const dataType = this.data_type;
      const showOutLine = this.showOutLine;
      const showNameAlways = this.showNameAlways;
      this.$store.commit("updateMapSatus", {
        point,
        zoom,
        timeType,
        dataType,
        showOutLine,
        showNameAlways,
      });
    },
    getLevelInfoDetail() {
      // 切换弹窗的时候关闭二级弹窗
      this.isShowLevelInfo = false;
      if (this.station.path) {
        const DevType = this.station.path.DevType;
        // 筛选对应等级标准，没有返回等级数值，则默认取等级为5的标准
        if (DevType) {
          this.levelInfoDetail = waterStandards.filter(
            (item) => item.level === DevType
          )[0];
        } else {
          // this.levelInfoDetail = waterStandards.filter(item => item.level === "5")[0]
          this.levelInfoDetail = null;
        }
      } else {
        this.levelInfoDetail = null;
      }
    },
    getLimitVal(data_type) {
      const limit = waterTypes.filter((item) => item.value === data_type)[0];
      if (limit) {
        return limit.limit;
      } else {
        return null;
      }
    },
    addInterval() {
      if (this.get_data_int) {
        clearInterval(this.get_data_int);
      }
      if (this.timep.value === "min") {
        this.get_data_int = setInterval(() => {
         this.getUserStationsFun('cur')
        }, 30000);
      } else {
        return;
      }
    },
    sensorColor(v) {
      let val = this.station.sensor[v];
      // val = val == '--' ? null : val
      if (!val || val == "--") {
        return {
          background: "gray",
          color: "#333",
        };
      } else {
        const bg = this.getIntensity(v).bgcolor.getColor(val);
        const fg = this.getIntensity(v).fgcolor.getColor(val);
        return {
          background: bg,
          color: fg,
        };
      }
    },
    sensorValue(v) {
      if (v && this.station.sensor[v]) {
        return this.$sensortypeRound(v, this.station.sensor[v]);
      } else {
        return "--";
      }
    },
    initMap() {
      var map = new BMap.Map("map", {
        enableMapClick: false,
        minZoom: 6,
      });
      map.enableScrollWheelZoom(true);
      map.enableDragging();
      if (this.page_config.use_map_style) {
        map.setMapStyle({ styleJson: map_theme });
      }
      const { point, zoom } = this.mapStatus;
      if (point && zoom) {
        map.centerAndZoom(new BMap.Point(point.lng, point.lat), zoom);
        this.map_zoom = zoom;
      }
      // 添加带有定位的导航控件
      var navigationControl = new BMap.NavigationControl({
        // 靠左上角位置
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        offset: new BMap.Size(10, 100),
        // LARGE类型
        type: BMAP_NAVIGATION_CONTROL_LARGE,
        // 启用显示定位
        enableGeolocation: true,
      });
      map.addControl(navigationControl);
      map.enablePinchToZoom();
      this.map = map;
      // map.addEventListener("moveend", self.updateOverlays);
      // 点击地图关闭耳机弹窗
      map.addEventListener("touchend", (e) => {
        this.isShowLevelInfo = false;
      });
      // 监听地图zoom事件
      map.addEventListener("zoomend", this.updateOverlays);
    },
    setMapCenter() {
      if (this.showInfoWindow) return;
      const { point, zoom } = this.mapStatus;
      if (!point || !zoom) {
        if (this.points_group && this.points_group.length) {
          const pts = this.points_group.map((x) => {
            if (x.info.path.Lng && x.info.path.Lat) {
              var lng = x.info.path.Lng;
              var lat = x.info.path.Lat;
              var p = new BMap.Point(lng, lat);
              return p;
            }
          });
          console.log("viewport");
          this.map.setViewport(pts);
        } else {
          console.log("centerzoom");
          // this.map.centerAndZoom(new BMap.Point(119.509085, 35.498484), 12);
          this.map.centerAndZoom(this.userInfo.City, 11);
        }
      }
    },
    clickRow(station) {
      var endTimePar =new Date(this.update_time).getTime();
      var params = {
        sn: station.path.DevSN,
        lng: station.path.Lng,
        lat: station.path.Lat,
        data_type: this.data_type,
        timep: this.timep.value,
        endTimePar: endTimePar,
      };
      console.log("clickRow", params);
      this.$router.push({ name: "detailData", params });
    },
    calcAvg() {
      var count = 0;
      var sum = 0;
      for (var p in this.points_group) {
        var p_info = this.points_group[p];
        var val = p_info.info.sensor[this.data_type];
        if (!val || val < 0 || val == "--") {
        } else {
          count += 1;
          sum += val;
        }
      }
      if (count > 0) {
        if (this.data_type == "cod" || this.data_type == "temperature") {
          this.avg_val = Math.round((sum / count) * 10) / 10;
        } else if (
          this.data_type == "ammonia_nitrogen" ||
          this.data_type == "ph"
        ) {
          this.avg_val = Math.round((sum / count) * 100) / 100;
        } else {
          this.avg_val = Math.round(sum / count);
        }
      } else {
        this.avg_val = "--";
      }
    },
    getUnit(data_type) {
      let unit = "";
      for (let item of this.option_data_type) {
        if (item.value === this.data_type) {
          unit = item.unit;
        }
      }
      return unit;
    },
    updateOverlays(flag) {
      this.map_zoom = this.map.getZoom();
      console.log(this.map_zoom, "updateOvers");
      if (this.map_zoom < 6) {
        this.map_zoom = 11;
      }
      if (this.map_zoom >= this.page_config.zoom_change_limit) {
        console.log("addViewOverlays");
        this.clearWzMarkersPoint();
        this.addViewOverlays();
      } else {
        console.log("drawMassFeatures");
        this.clearWzMarkers();
        this.drawMassFeatures();
      }
      this.drawGfStation();
    },
    overlayTouch(overlay, callback) {
      var obj = {};

      overlay.addEventListener("touchstart", function (e) {
        obj.e = e.changedTouches ? e.changedTouches[0] : e;
        obj.target = e.target;
        obj.time = Date.now();
        obj.X = obj.e.pageX;
        obj.Y = obj.e.pageY;
      });

      overlay.addEventListener("touchend", function (e) {
        this.clickInMarker = true;
        console.log("this.clickInMarker", this.clickInMarker);
        obj.e = e.changedTouches ? e.changedTouches[0] : e;
        if (
          obj.target === e.target &&
          // 大于 750 可看成长按了
          Date.now() - obj.time < 750 &&
          // 应用勾股定理判断，如果 touchstart 的点到 touchend 的点小于 15，就可当成地图被点击了
          Math.sqrt(
            Math.pow(obj.X - obj.e.pageX, 2) + Math.pow(obj.Y - obj.e.pageY, 2)
          ) < 15
        ) {
          // 地图被点击了，执行一些操作
          callback(overlay._station_info);
        }
      });
    },
    drawMassFeatures() {
      const sizeDict = {
        9: 14,
        10: 15,
        11: 16,
        12: 16,
        13: 27,
        14: 27,
        15: 27,
      };
      var self = this;
      // this.map.clearOverlays();
      this.clearWzMarkersPoint();
      var markers = [];
      var arrFeatures = [];
      var outlineFeatures = [];
      var zoom = this.map.getZoom();
      var size = sizeDict[zoom] || 14;
      var showText = false;
      if (zoom >= 13) {
        showText = true;
      }
      for (var p in this.points_group) {
        var p_info = this.points_group[p];
        if (!p_info.lng || !p_info.lat) {
          continue;
        }
        var lng = p_info.lng;
        var lat = p_info.lat;
        var point = new BMap.Point(lng, lat);
        var val = p_info.info.sensor[this.data_type];
        let color = this.intensity.bgcolor.getColor(val);
        let fgcolor = this.intensity.fgcolor.getColor(val);
        if (!val || val < 0 || val == "--") {
          if (!this.showOutLine) {
            continue;
          }
          color = "gray";
        }
        let overlay = new this.weizhanmassFeatures(
          point,
          size,
          color,
          p_info.info,
          fgcolor,
          showText,
          val
        );
        this.map.addOverlay(overlay);
        if (this.$is_mobile) {
          this.overlayTouch(overlay, self.openMapWindow);
        } else {
          overlay.addEventListener(
            "click",
            _.bind(function(e) {
              self.openMapWindow(overlay._station_info);
            })
          );
        }
        
        markers.push(overlay);
        // overlay.addEventListener(
        //   "touchstart",
        //   _.bind(function(e) {
        //     self.openMapWindow(overlay._station_info);
        //   })
        // );
      }
      this.wzMarkersPoints = markers;
      this.loadingpage = false;
    },
    clearWzMarkersPoint() {
      if (this.wzMarkersPoints.length) {
        for (let i of this.wzMarkersPoints) {
          this.map.removeOverlay(i);
        }
      }
    },
    addViewOverlays: _.debounce(function () {
      var self = this;
      // this.map.clearOverlays();
      this.clearWzMarkers();
      var markers = [];
      for (var p in this.points_group) {
        var p_info = this.points_group[p];
        if (p_info.lng && p_info.lat) {
          var lng = p_info.lng;
          var lat = p_info.lat;
        }
        var text = p_info.info.station.Name;
        var p = new BMap.Point(lng, lat);
        // p_info.info.sensor[this.data_type] = this.$sensortypeRound(this.data_type, p_info.info.sensor[this.data_type])
        var val = p_info.info.sensor[this.data_type];
        /* if (this.timep.value === "hour" || this.timep.value === "day") {
          p_info.info.sensor[this.data_type] = val > 0 ? val : "--";
        } else {
          p_info.info.sensor[this.data_type] = val > 0 ? val : "--";
        }

        */
        var val_intensity = val == "--" ? null : val;
        let bgcolor = this.intensity.bgcolor.getColor(val_intensity);
        let fgcolor = this.intensity.fgcolor.getColor(val_intensity);

        if (!val || val == "--" || val < 0) {
          if (!this.showOutLine) {
            continue;
          }
        }

        const unit = this.getUnit(this.data_type);
        var zoom = this.map.getZoom();
        var showText = zoom >= this.page_config.zoom_change_limit2;
        if (this.showNameAlways) {
          showText = true;
        }
        let overlay = new this.weizhanoverlayfn(
          p,
          p_info.info,
          this.data_type,
          fgcolor,
          bgcolor,
          unit,
          showText
        );
        this.map.addOverlay(overlay);
        markers.push(overlay);
        if (this.$is_mobile) {
          this.overlayTouch(overlay, self.openMapWindow);
        } else {
          overlay.addEventListener(
            "click",
            _.bind(function(e) {
              self.openMapWindow(overlay._station_info);
            })
          );
        }
        // overlay.addEventListener(
        //   "touchstart",
        //   _.bind(function(e) {
        //     self.openMapWindow(overlay._station_info);
        //   })
        // );
      }
      this.wzMarkers = markers;
    }, 150),
    clearWzMarkers() {
      if (this.wzMarkers.length) {
        for (let i of this.wzMarkers) {
          this.map.removeOverlay(i);
        }
      }
    },
    openMapWindow(station) {
      var self = this;
      var sn = station.path.DevSN;
      var lng = station.path.Lng;
      var lat = station.path.Lat;
      var id = station.path.ID;
      var pts = new BMap.Point(lng, lat);
      var h = window.location.href.split("#")[0];
      var param = sn + ":" + lng + ":" + lat;
      this.station = station;
      console.log("openMapWindow -> station", station);
      this.showInfoWindow = true;
      this.map.setCenter(pts);
    },
    teStore() {
      this.$store.dispatch("getGroupTree");
    },
    getColorRange(data_type) {
      if (!G_SENSOR_DATA_TYPE_INFO) {
        return;
      }
      let colorRange = [];
      G_SENSOR_DATA_TYPE_INFO.forEach((item) => {
        if (item.value === data_type) {
          colorRange[0] = item["color_range_min"];
          colorRange[1] = item["color_range_max"];
        }
      });
      return colorRange;
    },
    getIntensity(data_type) {
      return new colorIntensity.getIntensity({
        dataType: data_type,
        max: this.getColorRange(data_type)[1],
        min: this.getColorRange(data_type)[0],
        colorType: "static",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.option_data_type {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.option_data_type > div {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.option_data_type > div:nth-child(2n) {
  margin-left: 18px;
}
.tb_value {
  position: relative;
  font-size: 15px;
  text-align: center;
  display: inline-block;
  /* color: white; */
  height: 28px;
  line-height: 28px;
  min-width: 74px;
  border-radius: 4px;
}
.tb_label {
  font-size: 14px;
  color: #565656;
  display: inline-block;
  width: 36px;
}
.setting {
  position: absolute;
  top: 14px;
  right: 12px;
  z-index: 2;
}
.infotime {
  display: flex;
  font-size: 12px;
  color: #565656;
}
.levelInfo {
  font-size: 12px;
  color: deepskyblue;
}
.levelInfoDetail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25em;
  color: deepskyblue;
  font-size: 12px;
}
.screen_menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
.time-sel {
  background: rgb(250, 250, 252);
  padding-top: 4px;
}
.lable {
  color: rgb(90, 161, 221);
}
.screen_menu_text {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.select {
  text-align: center;
  width: 100%;
}
.data_th {
  min-width: 55px;
}
.offline_tip {
  position: absolute;
  top: 106px;
  left: 0;
  width: 100%;
  height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e2f0ff;
  box-sizing: border-box;
  z-index: 9;
}
.offline_tip > span {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1890ff;
}
.tag_marker {
  position: absolute;
  right: 6px;
  bottom: 80px;
  background-color: #fff;
  border-radius: 3px;
  padding: 4px 8px;
}
.baseipt {
  height: 18px;
  border: 1px solid rgb(229, 229, 229);
}
.calendar {
  position: absolute;
  right: 2px;
  top: 1px;
  z-index: 10;
}
</style>

<style >
.cir_font {
  display: none;
}
.main_container .van-overlay {
  background-color: transparent;
  height: 93%;
}
.el-popover {
  z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/mapData2.vue